import React from 'react';
import AppRouter from './app/router';

function App() {
  return <AppRouter />;
}

export default App;
